export default __webpack_public_path__ + "static/media/lock.png.webp";